var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"34ef5e47f3dc79f9488765f006a82e521b6fc32e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kodable-web-game@kodable-y7"]={id:"34ef5e47f3dc79f9488765f006a82e521b6fc32e"};
      